<app-main-bar></app-main-bar>

<mat-sidenav-container fullscreen>

  <mat-sidenav [mode]="mainNavigationMode" [opened]="mainNavigationOpened" class="mat-elevation-z4">
    <app-main-nav></app-main-nav>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-loading-bar></app-loading-bar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>

</mat-sidenav-container>